import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-scenario-tree',
  templateUrl: './scenario-tree.component.html',
  styleUrls: ['./scenario-tree.component.scss']
})
export class ScenarioTreeComponent {
  @Input() element: any;
  @Input() depth: number = 0;
  @Input() selectedElement: any;
  @Input() animations: any[];
  
  @Output() elementSelected = new EventEmitter<any>();
  @Output() elementDeleted = new EventEmitter<any>();

  @ViewChild('contentButton') contentButton: ElementRef;

  toggleExpanded(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.element.expanded = !this.element.expanded;
  }

  deleteElement(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.elementDeleted.emit(this.element);
  }

  addSubset(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    const newSubset = {
      id: this.generateUniqueId(),
      label: `New Subset`,
      options: [],
      expanded: true,
      animation: this.animations[0]
    };
    this.element.options.push(newSubset);
    // Maintain focus on the main button
    setTimeout(() => {
      this.contentButton.nativeElement.focus();
    });
  }

  selectElement() {
    this.elementSelected.emit(this.element);
  }

  onElementSelected(element: any) {
    this.elementSelected.emit(element);
  }

  onElementDeleted(element: any) {
    const index = this.element.options.indexOf(element);
    if (index > -1) {
      this.element.options.splice(index, 1);
    }
  }

  private generateUniqueId(): string {
    return 'id_' + Math.random().toString(36).substr(2, 9);
  }
}